const Card = ({ title, subtitle, headerExtra, className, children }) => {
  return (
    <div className={`card ${className || ''}`}>
      {title && (
        <h3>
          {title}
          {headerExtra && (
            <span style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 400 }}>
              {' '}{headerExtra}
            </span>
          )}
        </h3>
      )}
      {subtitle && (
        <div className="h-sub">{subtitle}</div>
      )}
      {children}
    </div>
  );
};

export default Card;